import { render } from "./NominaView.vue?vue&type=template&id=1fb66038"
import script from "./NominaView.vue?vue&type=script&lang=js"
export * from "./NominaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__